import { render, staticRenderFns } from "./listOfReservations.vue?vue&type=template&id=516c072a&"
import script from "./listOfReservations.vue?vue&type=script&lang=js&"
export * from "./listOfReservations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports